import fallbackImage from "../assets/img/agency-no-logo.jpg";

function getAgencyLogoURL(agencyLogoFileName?: string) {
    return agencyLogoFileName ? `${process.env.REACT_APP_AMAZON_URI}Content/images/agency/${agencyLogoFileName}` : fallbackImage;
}

export { getAgencyLogoURL };